import EF from 'ef/ef';
import Chaplin from 'chaplin';
import utils from 'lib/utils';

const Resource = Chaplin.Model.extend({
  initialize: function (attributes, options) {
    this.enrollment = options.enrollment;
    this.normalize(this);
  },
  normalize: function (resource) {
    let r = JSON.parse(JSON.stringify(resource));
    if (r.attributes) {
      r = utils.sanifyJsonApiObject(r);
    }
    if (r.esignature) {
      r.requires_e_signature = true;
    }
    if (r.type === 'content_business_policies') {
      r.type = 'PolicyResource';
    }
    if (r.type === 'business_resource_contents') {
      r.type = 'Resource';
    }
    if (r.content && !r.body) {
      r.body = r.content;
    }
    if (r.id && r.type) {
      r.id = `${r.type}-${r.id}`; // makes the id unique since collection is of two diff mixed types
    }
    if (r.slug) {
      r.sub_type = r.slug;
    }
    if (r.media_url && !r.url) {
      r.url = r.media_url;
    }
    if (r.type === 'PolicyResource') {
      if (r.body && !r.requires_e_signature) {
        r.requires_body_view = true;
      }
      if (r.url) {
        r.requires_link_click = true;
      }
    }
    resource.attributes = r;
  },
  url: function () {
    return EF.url(`/sdk/enrollments/${this.enrollment.get('id')}/resources/${this.get('id')}.json`);
  },
});

export default Resource;
